import React from "react"
import Socials from "../components/socials";

export default function FooterMenu({nodes, env})
{   
    const menu = [];       

    nodes.filter(node => (node.drupal_parent_menu_item === null)).map((item, index) => 
    { 
        const social = item.drupal_id === 'd8fe598b-5168-4393-9790-a2f4ca844d50' ? true : false;
        
        menu[index] = 
        {
            'drupal_id': item.drupal_id,
            'title': item.title,
            'social': social
        }

        return true;
    })

    menu.map((items) => 
    { 
        let submenu = [];

        const id = 'menu_link_content:'+items.drupal_id;
        
        nodes.filter(node => (node.drupal_parent_menu_item === id)).map((item, index) => 
        {
            submenu[index] =
            {
                'title': item.title,
                'url': item.link.uri.replace('internal:','')
            }   

            return true;
        });

        items.submenu = submenu;

        return true;
    }) 
    
    return(
        <div className="row">
        {                       
            menu.map((main, mainindex) => 
            {
                const show = mainindex === 2 ? true : false;               
               
                return (                                
                    <div key={mainindex} className="col-lg-4">
                        <ul className="footer-list">

                            <button className="collapser" type="button" data-toggle="collapse" data-target={"#collapse_"+main.drupal_id} aria-expanded="false" aria-controls={"collapse_"+main.drupal_id}>
                                {main.title}
                                <i className="fa fa-chevron-down"></i>
                            </button>
                            
                            <div className="collapse show" id={"collapse_"+main.drupal_id}>
                                {
                                main.submenu.map((link, index) => 
                                { 
                                    return (    
                                        <div key={index}>                                  
                                            <li>
                                                <a className="front-link" href={link.url}>{link.title}</a>
                                            </li>                                                        
                                        </div>                                               
                                    )
                                }) }
                                <Socials show={show} env={env} />
                            </div>                                         
                        </ul>
                    </div>
                )
            })
        }   
        </div>
    )
}